import { PAYG_EVENTS } from '@/src/constants/analytics';
import AnalyticsService from '@/src/services/analyticsService';
import React, { useEffect, useId, useRef } from 'react';
import {
  StyledBody,
  StyledButton,
  StyledContent,
  StyledDialog,
  StyledDismissButton,
  StyledHeading,
  StyledIllustration,
} from './styles';

const COIN_STACK_ILLUSTRATION_URL =
  'https://www.ovobyus.com/transform/ef6502e2-b222-451c-b4e1-ccd6ee39f48e/El-Coin-Stack-2?io=transform:fill,width:240,height:240&focuspoint=0.5,0.5&format=png';

interface Props {
  onClose: () => void;
}

// TODO: Replace with element-v5's ActionModal once this app upgrades from element-v5 5.1.4.
export const BalanceInfoModal = ({ onClose }: Props) => {
  const headingId = useId();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const isPressOnBackdrop = useRef(false);

  // Unlike unmounting, closing the dialog returns focus to the button that opened it.
  const close = () => dialogRef.current?.close();

  useEffect(() => {
    const dialog = dialogRef.current;
    // Older browsers throw if it's already open, e.g. when StrictMode runs this twice.
    if (dialog && !dialog.open) {
      dialog.showModal();
    }
    // Otherwise the close button gets focus and opens with a focus ring.
    dialog?.focus();
    AnalyticsService.dispatch(...PAYG_EVENTS.balanceExplainedViewed());
  }, []);

  return (
    <StyledDialog
      ref={dialogRef}
      tabIndex={-1}
      aria-labelledby={headingId}
      onClose={onClose}
      // A text selection dragged out of the content ends on the backdrop, so the press must start there too.
      onMouseDown={event => {
        isPressOnBackdrop.current = event.target === event.currentTarget;
      }}
      onClick={event => {
        if (isPressOnBackdrop.current && event.target === event.currentTarget) {
          close();
        }
      }}
    >
      <StyledContent>
        <StyledDismissButton
          inverted={false}
          withBorder={false}
          aria-label="Close"
          onClick={close}
        />
        <StyledIllustration src={COIN_STACK_ILLUSTRATION_URL} alt="" />
        <StyledHeading id={headingId} semanticComponent="h2">
          Your balance explained
        </StyledHeading>
        <StyledBody size="lg">
          Your balance doesn’t include emergency credit. If it runs out, you can
          accept emergency credit on your meter.
        </StyledBody>
        <StyledButton onClick={close}>OK</StyledButton>
      </StyledContent>
    </StyledDialog>
  );
};
